(function (upp) {
    'use strict';

    // Internal and private API for categories.
    // The own category must define its own appi extending this one.
    // Must be the only way the modules interact with the app
    upp.service('_appi', ['$rootScope', '$http', 'location', 'utils', 'modal',

        function ($rootScope, $http, location, utils, modal) {
            /**
             * Methods related to the location,urls,...
             */
            var _location = {

                /**
                 * Change the url of the webapp
                 *
                 * @method path
                 * @param {String} url
                 * @param {Boolean} applyDigest if explicitly want to make $rootScope.apply() to refresh the url
                 */
                path: function (url, applyDigest) {
                    location.path(url, applyDigest);
                },

                /**
                 * Open external url
                 *
                 * @method open
                 * @param {String} url
                 */
                open: function (url) {
                    location.open(url);
                },

                /**
                 * Open external url and, in phonegap, listen to changes in the url to apply functions
                 *
                 * @method open
                 * @param {String} url
                 * @param {Function} callback fired when the url change
                 * @param {Boolean} force, if we want to force to open in a new window
                 */
                openWindowInPhonegap: function (url, callback, force) {
                    return location.openWindowInPhonegap(url, callback, force);
                }
            };

            /**
             * Methods related to the user interface
             */
            var _ui = {
                modals: [],
                /**
                 * Should be called when a page is loading to hide the content with a modal spin
                 *
                 * @method showPageLoadingMsg
                 */
                showPageLoadingMsg: function () {
                    $rootScope.showPageLoadingMsg();
                },

                /**
                 * Should be called when the page is ready (data fetched), for example, to show the content and hide the modal spin
                 *
                 * @method hidePageLoadingMsg
                 */
                hidePageLoadingMsg: function () {
                    $rootScope.hidePageLoadingMsg();
                },

                /**
                 * Should be called when the page, that was loading, has had an error and we want to show a network error.
                 *
                 * @method showNetworkError
                 */
                showNetworkError: function () {
                    $rootScope.showNetworkError();
                },

                /**
                 * Changes the text of a module in the navigation bar
                 *
                 * @param {String} module
                 * @param {String} text
                 * @method changeNavText
                 */
                changeNavText: function (module, text) {
                    $rootScope.changeNavText(module, text);
                },

                /**
                 * Changes the name of the actual option in the top navbar in mobile
                 *
                 * @param {Object} textOptions. Properties to prepare the text to show in the menu:
                 *  If 'i18n' prop given, the text is translated
                 *  If 'moduleKey2Display' prop given, the text is given by the config service
                 *  Else, the own text is displayed
                 * @param {String} backNavigation, optional. If given, url where button should redirect, if not, should open navbar
                 * @method changeActualOption
                 */
                changeActualOption: function (textOptions, backNavigation) {
                    $rootScope.changeActualOption(textOptions, backNavigation);
                },

                /**
                 * Build a modal message
                 *
                 * @param {Object} params
                 * @method modalMessage
                 * @return Promise with the modal
                 */
                modalMessage: function (params) {
                    return modal.get({
                        templateUrl: require('../templates/modal_message.html'),
                        attrs: params
                    });
                },

                showBanner: function (params) {
                    return $rootScope.showBanner(params);
                },

                /**
                 * Shows an inline message
                 *
                 * @param {Object} params
                 * @method showInlineMessage
                 */
                showInlineMessage: function (params) {
                    $rootScope.showInlineError(params);
                }
            };

            /**
             * Utilities
             */
            var _utils = {

                /**
                 * Returns the 'id' of 'params' if it's has the following structure: {whatever}-{id}
                 *
                 * @method getIdFromParams
                 * @param {String} params
                 * @return {String} Returns id
                 */
                getIdFromParams: function (params) {
                    return utils.idFromParams(params);
                },

                /**
                 * Returns the html needed to create a breadcrumb with several steps, an actual one, and a next button
                 *
                 * @method navBarTemplate
                 * @param {String} actualTab Active tab in the navbar
                 * @param {Array} tabs Array of tabs. Each tab is an object that should have the following attributes: tab, link, label
                 * @return {String} Returns 'navbar' html
                 */
                navBarTemplate: function (actualTab, tabs) {
                    return utils.navBarTemplate(actualTab, tabs);
                },

                /**
                 * Returns the html needed to create a breadcrumb with several steps, an actual one, and a next button
                 *
                 * @method breadCrumbTemplate
                 * @param {String} actualStep Active step in the breadcrumb
                 * @param {Array} steps Array of steps. Each step is an object that should have the following attributes: step, label, next step info
                 * @param {String} nextDisabled Condition that disables the next button
                 * @return {String} Returns 'breadCrumb' html
                 */
                breadCrumbTemplate: function (actualStep, steps, nextDisabled) {
                    return utils.breadCrumbTemplate(actualStep, steps, nextDisabled);
                },

                /**
                 * Broadcast an event
                 *
                 * @method broadcast
                 * @param {String} event name of the event to be broadcasted
                 */
                broadcast: function (event) {
                    return utils.broadcast(event);
                }
            };

            /**
             * Methods related to asynchronous http access
             */
            var _http = {

                /**
                 * http get via ajax
                 *
                 * @method get
                 * @param {String} url Url of the service
                 * @param {Object} headers http headers to send (optional)
                 * @return {Promise} Returns a promise that will be fulfilled or rejected
                 */
                get: function (url, headers) {
                    return $http.get(url, headers);
                },

                /**
                 * http post via ajax
                 *
                 * @method post
                 * @param {String} url Url of the service
                 * @param {Object} params Params to send
                 * @param {Object} headers http headers to send (optional)
                 * @return {Promise} Returns a promise that will be fulfilled or rejected
                 */
                post: function (url, params, headers) {
                    return $http.post(url, params, headers);
                },

                /**
                 * http delete via ajax
                 *
                 * @method get
                 * @param {String} url Url of the service
                 * @param {Object} headers http headers to send (optional)
                 * @return {Promise} Returns a promise that will be fulfilled or rejected
                 */
                delete: function (url, headers) {
                    return $http.delete(url, headers);
                }
            };

            return {
                location: _location,
                ui: _ui,
                utils: _utils,
                http: _http
            }

        }])
    //
    // Public API
    //
        .service('appi', ['_appi', 'security', 'securityUtils',
            function (_appi, security, securityUtils) {

                var self = this;

                angular.copy(_appi, self);

                self.security = {
                    /**
                     * Check if the user is logged and has a valid session to enter a page.
                     * If he isn't, the app will redirect to a page where a message to sign is shown
                     *
                     * @method securable
                     * @return {Promise} Returns promise
                     */
                    securable: function (options) {
                        return security.securable(options);
                    },

                    /**
                     * return the current authentication
                     * @returns {Promise} with the authentication never null or anonymous or the auth with principal
                     */
                    getAuthentication: function () {
                        return security.initialize();
                    }
                };

                /**
                 * http get via ajax
                 *
                 * @method getSecure
                 * @param {String} url Url of the service
                 * @return {Promise} Returns a promise that will be fulfilled or rejected
                 */
                self.http.getSecure = function (url) {
                    return self.http.get(url, securityUtils.getHttpAuthHeader());
                };

                /**
                 * http post via ajax  with secure auth header
                 *
                 * @method postSecure
                 * @param {String} url Url of the service
                 * @param {Object} params Params to send
                 * @return {Promise} Returns a promise that will be fulfilled or rejected
                 */
                self.http.postSecure = function (url, params) {
                    return self.http.post(url, params, securityUtils.getHttpAuthHeader());
                };

                /**
                 * http delete via ajax  with secure auth header
                 *
                 * @method deleteSecure
                 * @param {String} url Url of the service
                 * @return {Promise} Returns a promise that will be fulfilled or rejected
                 */
                self.http.deleteSecure = function (url) {
                    return self.http.delete(url, securityUtils.getHttpAuthHeader());
                };

            }]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/common/services/appi-service.js